import { useContext } from "react";
import { Link } from "react-router-dom";
import ExternalLink from "../../../assets/externalLink";
import { Context, IContext } from "../../../context/ContextApp";
import { subdomainTypes } from "../../../context/availableSubdomains";
import { subMenuLinks } from "./data";

interface Props {
  jwt: string;
}

const SublimationSubMenu = ({ jwt }: Props) => {
  const sublimationWebsite = process.env.REACT_APP_SUBLIMATION_WEBSITE;
  const { appBranch }: IContext = useContext(Context);

  return (
    <div>
      {subMenuLinks.map((category, index) => (
        <div key={index} role="menuitem">
          <Link
            to=""
            onClick={() =>
              window.open(
                category.isExternalLink
                  ? category.targetLink
                  : `${sublimationWebsite}${category.targetLink}?jwt=${jwt}`,
                "_blank",
              )
            }
          >
            <span style={{ textTransform: "capitalize" }}>{category.title}</span>
            <div className="expand-icon">
              <ExternalLink width={15} fill="white" />
            </div>
          </Link>

          {category.subMenuLink?.map((subLinks, linkIndex) => (
            <a
              key={linkIndex}
              href={appBranch === subdomainTypes.NZ ? subLinks.nz : subLinks.au}
              target="_blank"
              rel="noreferrer"
            >
              <span className="submenu-links" style={{ marginLeft: "15px" }}>
                {subLinks.title}
              </span>
            </a>
          ))}
        </div>
      ))}
    </div>
  );
};

export default SublimationSubMenu;
